import { css } from 'linaria';

export const inputContainer = css`
  display: none;
`;
